import { MdEditor, config } from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';

// Disable HTML rendering in the editor's internal markdown-it instance
// to prevent XSS in the preview pane. Matches the html:false config
// used by the read-only EventDetailsSection and EventRulesSection.
config({
  markdownItConfig(md) {
    md.set({ html: false });
  },
});

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('MdEditorV3', MdEditor);
});
